import { Component, Input, OnInit } from '@angular/core';
import { Objectifs, Performances } from 'src/app/core/model/performances';

@Component({
  selector: 'app-historique-performance',
  templateUrl: './historique-performance.component.html',
  styleUrls: ['./historique-performance.component.css']
})
export class HistoriquePerformanceComponent implements OnInit {

  @Input() PERFORMANCE: any
  @Input() OBJECTIF_ANNEE_COURS: any
  @Input() RESULTATS: any
  public listPerformances: any = [];
  public response: any;
  public commentaire: any;
  public valeur: any;
  public arrayObjectifs: any = [];
  public typeVisualisation: any;
  public resultat_objectif_performances: any = 0;
  public result: any = 0;
  public dataLength = 0;
  public typeFiche: any;
  public entretien_id: any;
  public agent_id: any;
  public appreciation_performance: any;
  public nbre_rubrique_evaluee: any = 0;
  public typeSauvegarde: any;
  public itemChecked: any = [];
  public listObjectifAnnee: any = [];
  public arrayObjectifsAnnee: any = [];
  public resultat_objectif_annee: any = 0;
  public listBarem: any;
  public nbre_rubrique_evaluee_objectif: any = 0;
  public nbre_rubrique_evaluee_global: any;
  public appreciation_objectif_annee: any;
  public description: any;
  public Performances: Performances = new Performances();
  public Objectifs: Objectifs = new Objectifs([], 0);
  public appreciation_global: any;
  public note_global: any = 0;
  public note_objectif_annee: any;
  public note_performances: any;
  public API_URL: any;
  public vueActive: any;
  public statut: any;

  constructor() { }

  public ngOnInit(): void {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    // console.log('URL IS :', url);
    // console.log('typeFiche IS :', this.typeFiche);
    // console.log('typeSauvegarde IS :', this.typeSauvegarde);
    // console.log('typeVisualisation IS :', this.typeVisualisation);
    // console.log('statut IS :', this.statut);
    // console.log('vueActive IS :', this.vueActive);
    // console.log('entretien_id IS :', this.entretien_id);
    // console.log('agent_id IS :', this.agent_id);
    this.getAllObjectifByUser();
    this.getAllObjectifAnneeByUser();
    this.getAllBareme();

    this.note_global = this.RESULTATS?.synthese_performance_tt?.note;
    this.nbre_rubrique_evaluee_global = this.RESULTATS?.synthese_performance_tt?.nbre;;
    this.appreciation_global = this.RESULTATS?.synthese_performance?.appreciation_synthese_performance;
  }

  containsObject(id_row) {
    let i;
    for (i = 0; i < this.arrayObjectifs?.length; i++) {
      if (this.arrayObjectifs[i].id === id_row) {
        return true;
      }
    }
    return false;
  }

  containsObjectArrayObjectifs(id_objectif) {
    let i;
    for (i = 0; i < this.arrayObjectifs?.length; i++) {
      if (this.arrayObjectifs[i].id === id_objectif) {
        return true;
      }
    }
    return false;
  }

  isChecked(objectif_id, notations_id) {
    const is_exist = this.containsObjectArrayObjectifs(objectif_id);
    if (!is_exist) {
      this.arrayObjectifs.push({
        id: objectif_id,
        barem_id: notations_id,
      });
      this.dataLength++;
    } else {
      const new_array = this.arrayObjectifs.filter(
        (element) => element.id !== objectif_id
      );
      this.arrayObjectifs = new_array;
      this.arrayObjectifs.push({
        id: objectif_id,
        barem_id: notations_id,
      });
    }
    return this.arrayObjectifs;
  }

  getAllObjectifByUser() {
    // this.nbre_rubrique_evaluee = this.PERFORMANCE?.note?.nbre;
    // this.resultat_objectif_performances = this.PERFORMANCE?.note?.valeur;
    // this.appreciation_performance = this.PERFORMANCE?.note?.appreciation;
    // this.result = this.PERFORMANCE?.note?.valeur;
    // this.note_performances === undefined ? this.note_performances = 0 : this.note_performances = this.PERFORMANCE?.note?.valeur;
    // this.response = res;

    this.nbre_rubrique_evaluee = this.RESULTATS?.synthese_performance_tt?.nbre
    this.resultat_objectif_performances = this.RESULTATS?.synthese_performance_tt?.note
    this.appreciation_performance = this.RESULTATS?.synthese_performance?.appreciation_synthese_performance

    this.listPerformances = this.PERFORMANCE;
    // console.log('Performa:', this.listPerformances);
    this.commentaire = this.PERFORMANCE?.description;
    // this.dataLength = this.listPerformances?.length;
    this.compterResultatObjectif(this.listPerformances);
    // this.arrayObjectifs = this.listPerformances;
    const arrayPerformancesChecked = [];
    this.listPerformances.forEach(element => {
      // tslint:disable-next-line: no-shadowed-variable
      arrayPerformancesChecked.push(element.notations.find(element => element.ischecked === true));
    });
    this.dataLength = arrayPerformancesChecked?.length - 2;
    if (arrayPerformancesChecked?.length > 0) {
      arrayPerformancesChecked.forEach(element => {
        this.arrayObjectifs.push(
          {
            'id': element?.objectif_id,
            'barem_id': element?.id
          }
        );
      });
    }
  }

  compterResultatObjectif(data) {
    data.forEach((element) => {
      if (element.valeur) {
        this.arrayObjectifs.push({
          id: element.id,
          note: element.valeur,
        });
      }
    });
  }


  containsObjectObjectifAnnee(id_row) {
    let i;
    for (i = 0; i < this.arrayObjectifsAnnee?.length; i++) {
      if (this.arrayObjectifsAnnee[i].id === id_row) {
        return true;
      }
    }
    return false;
  }

  isCheckedObjectifAnnee(id_row, description, id_barem) {
    const is_exist = this.containsObjectObjectifAnnee(id_row);
    let new_array = [];
    if (!is_exist) {
      this.arrayObjectifsAnnee.push({
        id: id_row,
        description: description,
        barem_id: id_barem,
      });
    } else {
      new_array = this.arrayObjectifsAnnee.filter(
        (element) => element.id !== id_row
      );
      this.arrayObjectifsAnnee = new_array;
      this.arrayObjectifsAnnee.push({
        id: id_row,
        description: description,
        barem_id: id_barem,
      });
    }
  }

  getAllBareme() {

    // this.response = res;
    this.listBarem = this.response?.data;
    this.Objectifs.notations = this.listBarem;
  }

  getAllObjectifAnneeByUser() {
    this.listObjectifAnnee = this.OBJECTIF_ANNEE_COURS;
    this.dataLength = this.listObjectifAnnee?.length;

    this.Performances.objectifs = this.listObjectifAnnee;
    this.arrayObjectifsAnnee = this.listObjectifAnnee;
    this.Performances.objectifs = this.listObjectifAnnee;

    // tslint:disable-next-line:max-line-length
    this.note_objectif_annee = this.RESULTATS?.note?.valeur;
    this.nbre_rubrique_evaluee_objectif = this.OBJECTIF_ANNEE_COURS?.length;
    this.resultat_objectif_annee = this.RESULTATS?.objectif_annee_encours?.resultat_objectif_annee_encours;
    this.appreciation_objectif_annee = this.RESULTATS?.objectif_annee_encours?.appreciation_objectif_annee_encours;

  }

  public checkSums(data) {
    let totalSums
    let barems = [] as any
    let newArray = []
    for (const value of data) {
      for (const row of value.notations) {
        if (row.ischecked) {
          newArray.push(row);
        }
      }
    }

    // newArray.forEach((element) => {
    //   barems.push(element.va)
    // });


    totalSums = newArray.reduce(
      (acc, item) => acc + parseInt(item.valeur),
      0
    );

    return totalSums
  }

}
